import { Injectable, EventEmitter, Component, Inject } from '@angular/core';
import {of, from} from 'rxjs';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

import {ApiService} from '../shared/api.service';
import { SImage } from './image.model';
import { catchError, takeUntil, mergeMap } from 'rxjs/operators';
import { Utils } from '../utils';
    
@Injectable()
export class ImagesService {
    cancelUpload = new EventEmitter();
    images = [];
    imageUploaded = new EventEmitter();
    imagesLoaded = new EventEmitter();
    imagesChange = new EventEmitter();
    imageDeleted = new EventEmitter();
    progress = 0;
    progressTotal = 0;
    progressCount = 0;
    tempImages = [];
    uploadComplete = new EventEmitter();
    uploadInProgress = false;
    regenerating = false;
    showCheck = false;
    error = '';
    refreshIds = [];

    constructor(
        private api: ApiService, 
        public dialog: MatDialog
    ) {}
    deleteImage(slides, assignment, img) {
        let dialog = this.dialog.open(ImageDeletehDialog, {
            data: {
                img: img
            }
        });
        dialog.afterClosed().subscribe(yes => {
            if( yes ) {
                const id = img.id;
                const lastIndex = slides.length - 1;
                for(var i = 0; i < slides.length; i++) {
                    const slide_id = slides[i].id;
                    const images = slides[i].images;
                    let j = images.length;
                    while(j--) {
                        const image = images[j];
                        if( image.id == id ) {
                            if( img.slides.indexOf(slide_id) === -1 ) {
                                img.slides.push(slide_id);
                            }
                            slides[i].images.splice(j, 1);
                        }
                    }
                    const imagesMobile = slides[i].imagesMobile;
                    let m = imagesMobile.length;
                    while(m--) {
                        const mobileImage = imagesMobile[m];
                        if( mobileImage.id == id ) {
                            if( img.slides.indexOf(slide_id) === -1 ) {
                                img.slides.push(slide_id);
                            }
                            slides[i].imagesMobile.splice(m, 1);
                        }
                    }
                    if( i == lastIndex ) {
                        const content = slides[i].content;
                        let k = content.length;
                        while(k--) {
                            const item = content[k];
                            if( item.image && item.image.id == id ) {
                                if( img.slides.indexOf(slide_id) === -1 ) {
                                    img.slides.push(slide_id);
                                }
                                delete slides[i].content[k].image;
                            }
                        }
                    }
                }
                let l = this.images.length;
                while(l--) {
                    const image = this.images[l];
                    if( image.id == id ) {
                        this.images.splice(l, 1);
                    }
                }
                this.imagesChange.emit(this.images);
                this.imageDeleted.emit(true);
                this.doDelete(img);
            } else {
                this.imageDeleted.emit(false);
            }
        });
    }
    doDelete(img) {
        this.api.doAction('post', 'image', {
            action: 'delete',
            image: img
        }).subscribe(
            data => {
                // if we want to add an undo function this will return data.previous
            }
        );
    }
    getTempId() {
        return Math.floor(Math.random()*90000) + 10000;
    }
    updateProgress() {
        const total = this.progressTotal;
        const progress = (this.progressCount / total) * 100;
        this.progress = Math.round(progress);
    }
    cancelUploading() {
        this.tempImages = [];
        this.cancelUpload.emit(false);
    }
    uploadFile(data) {
        return this.api.doAction('files', 'upload', data );
    }
    handleDropFiles(files, assignment, emit) {
        this.cancelUpload.emit(false);
        this.uploadInProgress = true;
        const len = files.length;
        this.progressTotal += len;
        const id = assignment.id;
        let errors = [];
        let fileForms = [];
        for(var i = 0; i < len; i++) {
            const formData = new FormData();
            const file = files.item(i);
            const title = file.name.replace(/\.[^/.]+$/, '').replace(/-_/, ' ');
            const tempId = this.getTempId();
            formData.append('file', file);
            formData.append('title', title);
            formData.append('alt_text', title);
            formData.append('post', id);
            formData.append('tempId', tempId + '');
            file.tempId = tempId
            this.tempImages.push(file);
            fileForms.push(formData);
        }
        const uploadSubscription = from(fileForms).pipe(
            mergeMap(formData => {
                return this.uploadFile(formData).pipe(
                    catchError(err => {
                        const image = formData.get('file');
                        if( !err.error ) {
                            image.error = err;
                        } else {
                            image.error = err.error;
                        }
                        return of(image);
                    })
                )
            }),
            takeUntil(this.cancelUpload)
        ).subscribe(
            data => {
                let tempImages = this.tempImages;
                let i = tempImages.length;
                while(i--) {
                    if( tempImages[i].tempId == data['tempId'] ) {
                        tempImages.splice(i, 1);
                        break;
                    }
                }
                if( data.hasOwnProperty('error') ) {
                    errors.push(data);
                } else {
                    const image = new SImage(data);
                    if (image && image.sizes && !image.sizes['feed_applenews']) {
                        this.resetAppleNewsSize(image);
                    }
                    this.images.unshift(image);
                    if( emit ) {
                        this.imageUploaded.emit(image);  
                    }
                    
                }
                this.progressCount += 1;
                this.updateProgress();
            },
            err => {
                const errors = JSON.parse(JSON.stringify(this.tempImages));
                this.handleServerErrors(errors);
                this.tempImages = [];
                this.uploadInProgress = false;
                this.progress = 0;
                this.progressTotal = 0;
                this.progressCount = 0;
                console.log('Error uploading images.', err);
            },
            () => {
                this.handleImageErrors(errors);
                this.uploadInProgress = false;
                this.progress = 0;
                this.progressTotal = 0;
                this.progressCount = 0;
                if( uploadSubscription ) {
                   uploadSubscription.unsubscribe(); 
                }
                if( this.tempImages.length == 0 ) {
                    this.uploadComplete.emit(this.images);
                }
            }
        )
    }
    handleImageErrors(errors) {
        if( errors.length === 0 ) {
            return;
        }
        for(var i = 0; i < errors.length; i++) {
            this.imageUploaded.emit({error: true, image: errors[i]})
        }
        this.dialog.open(ImagesErrorhDialog, {
            data: {
                images: errors
            }
        });
    }
    handleServerErrors(errors) {
        if( errors.length === 0 ) {
            return;
        }
        this.dialog.open(ServerErrorDialog, {
            data: {
                images: errors
            }
        });
    }
    getImagesFromApi(page, exclude, parent) {
        this.api.doAction('post', 'image', {
            action: 'read',
            exclude: exclude,
            parent: parent,
            per_page: 100,
            page: page
        }).subscribe(
            data => {
                const imagesIds = this.images.map(item => item.id);
                for(var i = 0; i < data.length; i++) {
                    const image = new SImage(data[i]);
                    if( imagesIds.indexOf(image.id) === -1 ) {
                        this.images.push(image);
                    }
                }
                this.imagesLoaded.emit(this.images);
            },
            err => {
                console.log('Error getting images.', err);
            }
        );
    }
    loadImages(assignment, slides) {
        let exclude = [];
        let added = [];
        for(var i = 0; i < slides.length; i++) {
            const slide = slides[i];
            let slideImages = slides[i].images;
            let imagesMobile = slides[i].imagesMobile;
            let quizResults = (assignment.childType == 'quiz' && slide.outro);
            for(var k = 0; k < slideImages.length; k++) {
                let image = new SImage(slideImages[k]);
                if( slide.intro && k == 0 ) {
                    assignment.featured_media = image.id;
                }
                if( added.indexOf(image.id) === -1 ) {
                    this.images.push(image);
                    added.push(image.id);
                } else {
                    image = this.images.filter(item => item.id == image.id).shift() || image;
                }
                if( !quizResults ) {
                    image.slides.push(slides[i].id);
                    slides[i].images[k] = image;
                }
                exclude.push(image.id);
            }
            for(var l = 0; l < imagesMobile.length; l++) {
                let image = new SImage(imagesMobile[l]);
                if( added.indexOf(image.id) === -1 ) {
                    this.images.push(image);
                    added.push(image.id);
                } else {
                    image = this.images.filter(item => item.id == image.id).shift() || image;
                }
                if( !quizResults ) {
                    slides[i].imagesMobile[l] = image;                  
                }
                exclude.push(image.id);
            }
            if( quizResults ) {
                const content = slides[i].content;
                for(var m = 0; m < content.length; m++) {
                    const quizImage = content[m].image;
                    const quizMobileImage = content[m].mobileImage;
                    if( quizImage ) {
                        const found = this.images.filter(item => item.id == quizImage.id);
                        if( found.length > 0 ) {
                            content[m].image = found[0];
                        } else {
                            const quizSwarmImage = new SImage(quizImage);
                            content[m].image = quizSwarmImage;
                            this.images.push(quizSwarmImage);
                            added.push(quizSwarmImage.id);
                            exclude.push(quizSwarmImage.id);
                        }
                    }
                    if( quizMobileImage ) {
                        const found = this.images.filter(item => item.id == quizMobileImage.id);
                        if( found.length > 0 ) {
                            content[m].mobileImage = found[0];
                        } else {
                            const quizSwarmMobileImage = new SImage(quizMobileImage);
                            content[m].mobileImage = quizSwarmMobileImage;
                            this.images.push(quizSwarmMobileImage);
                            added.push(quizSwarmMobileImage.id);
                            exclude.push(quizSwarmMobileImage.id);
                        }
                    }
                }
            }
        }
        this.imagesChange.emit(this.images);
        const parent = assignment.id;
        const subscription = this.imagesLoaded.subscribe(page => {
            if( page < this.api.getProp('foundPosts') ) {
                this.getImagesFromApi(page+1, exclude, parent);
            } else {
                subscription.unsubscribe();
            }
        });
        this.getImagesFromApi(1, exclude, parent);
    }
    refreshImage(id, url, size) {
        const els = document.querySelectorAll('[data-image-id="' + id + '"]');
        for(var i = 0; i < els.length; i++) {
            const el = els[i];
            const attrSize = el.getAttribute('data-image-size');
            if( size !== attrSize ) continue;
            
            const v = new Date().getTime();
            const tag = el.tagName.toLowerCase();
            if( url.indexOf('?') !== -1 ) {
               url += '&v=' + v; 
            } else {
                url += '?v=' + v;
            }
            
            if( tag == 'img' ) {
                el.setAttribute('src', url);
            } else {
                el.setAttribute('background-image', 'url(' + url + ')');
            }
        }
    }
    resetMobileSize(image, keep) {
        image.allowLandscape = false;
        if( image.sizes.mobile && keep ) {
            return;
        }
        image.sizes.mobile = {
            width: 480,
            height: 720,
            orientation: 'portrait'
        };
        image.sizes.mobile.urlWithParams = image.url + image.buildHttpParams(image.sizes.mobile);
        if( image.crop ) {
            image.sizes.mobile.crop = {
                b: image.crop.b,
                c: image.crop.c,
                width: 480,
                height: 720
            }
            image.sizes.mobile.urlWithParams = image.url + image.buildHttpParams(image.sizes.mobile.crop);
        }
        this.refreshImage(image.id, image.sizes.mobile.urlWithParams, 'mobile');
        this.imagesChange.emit(this.images);
    }
    resetMobileSizeAll(refreshOnly = true) {
        const images = this.images;
        for(var i = 0; i < images.length; i++) {
            const image = images[i];
            if( !image.allowLandscape || !refreshOnly) {
                this.resetMobileSize(images[i], refreshOnly);
            }
        }
    }
    resetDesktopSize(image, keep) {
        if( image.sizes.desktop && keep ) {
            return;
        }
        image.allow600 = false;
        image.allowPortrait = false;
        image.sizes.desktop = {
            width: 800,
            height: 533,
            orientation: 'landscape'
        };
        image.sizes.desktop.urlWithParams = image.url + image.buildHttpParams(image.sizes.desktop);
        if( image.crop ) {
            image.sizes.desktop.crop = {
                b: image.crop.b,
                c: image.crop.c,
                width: 800,
                height: 533
            }
            image.sizes.desktop.urlWithParams = image.url + image.buildHttpParams(image.sizes.desktop.crop);
        }
        this.refreshImage(image.id, image.sizes.desktop.urlWithParams, 'desktop');
        this.imagesChange.emit(this.images);
    }
    resetQuizSize(image) {
        image.sizes.quiz = {
            width: 756,
            height: 331
        };
        image.sizes.quiz.urlWithParams = image.url + image.buildHttpParams(image.sizes.quiz);
        if( image.crop ) {
            image.sizes.quiz.crop = {
                b: image.crop.b,
                c: image.crop.c,
                width: 756,
                height: 331
            }
            image.sizes.quiz.urlWithParams = image.url + image.buildHttpParams(image.sizes.quiz.crop);
        }
        this.refreshImage(image.id, image.sizes.quiz.urlWithParams, 'quiz');
        this.imagesChange.emit(this.images);
    }
    resetAdSize(image) {
        image.sizes.ad = {
            width: 1200,
            height: 628
        };
        image.sizes.ad.urlWithParams = image.url + image.buildHttpParams(image.sizes.ad);
        if( image.crop ) {
            image.sizes.ad.crop = image.crop;
        }
        if( image.sizes.ad.crop ) {
            image.sizes.ad.crop.width = 1200;
            image.sizes.ad.crop.height = 628;
            image.sizes.ad.urlWithParams = image.url + image.buildHttpParams(image.sizes.ad.crop);
        }
        this.refreshImage(image.id, image.sizes.ad.urlWithParams, 'ad');
        this.imagesChange.emit(this.images);
    }
    resetAppleNewsSize(image) {
        image.sizes.feed_applenews = {
            width: 800,
            height: 800
        };
        image.sizes.feed_applenews.urlWithParams = image.url + image.buildHttpParams(image.sizes.feed_applenews);
        if( !image.sizes.feed_applenews.crop ) {
            if (image.sizes.desktop && image.sizes.desktop.crop) {
                image.sizes.feed_applenews.crop = image.sizes.desktop.crop;
            } else if( image.crop ) {
                image.sizes.feed_applenews.crop = image.crop;
            }
        }
        if( image.sizes.feed_applenews.crop ) {
            image.sizes.feed_applenews.crop.width = 800;
            image.sizes.feed_applenews.crop.height = 800;
            image.sizes.feed_applenews.urlWithParams = image.url + image.buildHttpParams(image.sizes.feed_applenews.crop);
        }
        this.refreshImage(image.id, image.sizes.feed_applenews.urlWithParams, 'feed_applenews');
        this.imagesChange.emit(this.images);
    }
    resetDesktopSizeAll(refreshOnly = true) {
        const images = this.images;
        for(var i = 0; i < images.length; i++) {
            const image = images[i];
            if( (!image.allowPortrait && !image.allow600 && !this.isMobileOnlyImage(image)) || !refreshOnly) {
                this.resetDesktopSize(images[i], refreshOnly);
            }
        }
    }
    setSmallDesktop(img) {       
        img.allow600 = true;
        delete img.sizes.desktop;
        const image = img.sizes['full'];
        const width = image.width >= 600 ? image.width : 600;
        const height = img.height * (width / image.width);
        const newCrop = {
            width: width,
            height: Math.round(height)
        };
        if( image.crop && (image.crop.b || image.crop.c) ) {
            newCrop['b'] = image.crop.b;
            newCrop['c'] = image.crop.c;
        }
        image.crop = newCrop;
        img.crop = newCrop;
        image.urlWithParams = img.url + img['buildHttpParams'](image.crop);
        this.imagesChange.emit(this.images);
    }
    isMobileOnlyImage(image) {
        return !image.sizes.desktop && image.sizes.full.width < 600 && ( !image.crop || !image.crop.width || image.crop.width < 600 );
    }
    getDownloadUrl(image, size = 'none') {
        if( !image.sizes[size] ) {
            return image.urlWithParams + '&download=1';
        }
        return image.sizes[size].urlWithParams + '&download=1';
    }
    reset() {
        this.images = [];
        this.tempImages = [];
        this.uploadInProgress = false;
        this.progress = 0;
        this.progressTotal = 0;
        this.progressCount = 0;
    }
}
@Component({
    selector: 'server-error-dialog',
    template: `
        <h2 mat-dialog-title>Upload Error</h2>
        <mat-dialog-content>
            <p>There was an unexpected error. Please try again.</p>
            <p>{{data.name}}</p>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button class="button" mat-dialog-close>Ok</button>
        </mat-dialog-actions>`,
})
export class ServerErrorDialog {
    constructor( @Inject(MAT_DIALOG_DATA) public data: any) { }
}
@Component({
    selector: 'upload-progress-dialog',
    template: `
        <h2 mat-dialog-title>Upload In Progress</h2>
        <mat-dialog-content>
            <p>Please wait for the current images to upload before inserting more images.</p>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button class="button" mat-dialog-close>Ok</button>
        </mat-dialog-actions>`,
})
export class UploadInProgressDialog {
    constructor( @Inject(MAT_DIALOG_DATA) public data: any) { }
}
@Component({
    selector: 'images-error-dialog',
    template: `
        <h2 mat-dialog-title>Upload Error</h2>
        <mat-dialog-content>
            The following images could not be uploaded:
            <div class="image-holder" *ngFor="let img of data.images; trackBy: utils.trackByIndex">
                {{img.name}} - {{img.error.message}}
            </div>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button class="button" mat-dialog-close>Ok</button>
        </mat-dialog-actions>`,
})
export class ImagesErrorhDialog {
    constructor( @Inject(MAT_DIALOG_DATA) public data: any, public utils: Utils) { }
}
@Component({
    selector: 'image-delete-dialog',
    template: `
        <h2 mat-dialog-title>Are you sure?</h2>
        <mat-dialog-content>
            <p>Are you sure you want to permanently delete this image?</p>
            <img src="{{data.img?.sizes.full.urlWithParams}}" />
        </mat-dialog-content>
        <mat-dialog-actions>
            <button class="button" mat-dialog-close>Cancel</button>
            <button class="button" [mat-dialog-close]="true">Delete</button>
        </mat-dialog-actions>`,
})
export class ImageDeletehDialog {
    constructor( @Inject(MAT_DIALOG_DATA) public data: any) { }
}